export enum VehicleApplicationVersionStatus {
    PENDING = 1,    // Pendiente
    SENT = 2,       // Enviado
}